import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import { Theme } from '../../styles/settings/theme'
import { MediaQueries as Mq } from '../../styles/settings/theme'

import { Flex, Content } from '../atoms/Basics'
import ChartTitle from '../atoms/ChartTitle'
import ChartContainer from '../atoms/ChartContainer'
import PercentTickAxis from '../atoms/PercentTickAxis'
import LegendColors from '../atoms/LegendColors'
import Subtitle from '../atoms/Subtitle'

const RowFlex = styled(Flex)`
  align-items: center;
  margin: 0 1rem 0.75rem;
`
const Label = styled.div`
  color: ${(props) => props.theme.colors.gray};
  margin: 0 1rem 0 0;
  //min-width: 16rem;
  width: 17rem;
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: 600;
  text-align: right;
  ${Mq.md} {
    font-size: 12px;
    width: 11rem;
  }
  ${Mq.sm} {
    font-size: 11px;
    width: 9rem;
  }
  ${Mq.xs} {
    font-size: 10px;
    width: 7.5rem;
  }
`
const BaseBar = styled.div`
  flex: 1;
  height: 2.25rem;
  background-color: ${(props) => props.theme.colors.gray1};
  position: relative;
`
const RankBar = styled.div`
  position: absolute;
  top: 0;
  left: ${(props) => props.left}%;
  background-color: ${(props) => props.color};
  height: 2.25rem;
  width: ${(props) => props.width}%;
`

const TickContainer = styled.div`
  flex: 1;
  position: relative;
  height: 7rem;
`

const Optimism = () => {
  const $ = window.WILDLABS_VARS
  const [data, setData] = useState(null)
  useEffect(() => {
    csv('./data/optimism.csv').then((data) => {
      setData(data)
    })
  }, [])

  const colors = [
    Theme.colors.darkGreen,
    Theme.colors.green,
    Theme.colors.lightGreen,
    Theme.colors.gray4,
    Theme.colors.gray3,
    Theme.colors.gray2,
    Theme.colors.gray1
  ]

  const allBars = [
    $.optimism_columns.First,
    $.optimism_columns.Second,
    $.optimism_columns.Third,
    $.optimism_columns.Fourth,
    $.optimism_columns.Fifth,
    $.optimism_columns.Sixth
  ]

  //gets array of column names to sum
  const bars = (i) => {
    return allBars.slice(0, i)
  }

  //sums all previous bars to find starting point of new bar
  const calcValue = (i, row) => {
    const colsToSum = bars(i)
    return colsToSum.reduce((acc, curr) => {
      return acc + +row[curr]
    }, 0)
  }

  const dataSorted = data?.sort((a, b) => {
    return a[$.optimism_columns.Eight] - b[$.optimism_columns.Eight]
  })
  return (
    <ChartContainer>
      <ChartTitle text={$.optimism_titles.chartTitle} />
      <Content flexDirection="column">
        <RowFlex justifyContent="space-between">
          <LegendColors colors={colors} columns={data?.columns.slice(1)} />
        </RowFlex>
        <RowFlex>
          <Label></Label>
          <TickContainer>
            <Flex justifyContent="center">
              <Subtitle
                text={$.optimism_titles.subtitle}
                size={Theme.fontSizes[2]}
                color={Theme.colors.gray}
                wide={true}
              ></Subtitle>
            </Flex>
            <PercentTickAxis />
          </TickContainer>
        </RowFlex>
        {dataSorted?.map((row, i) => (
          <RowFlex key={row.rank}>
            <Label>{row.rank}</Label>
            <BaseBar>
              {colors.map((color, i) => (
                <RankBar
                  key={`${color} + i`}
                  color={color}
                  left={calcValue(i, row) * 100}
                  width={allBars[i] ? row[allBars[i]] * 100 : 0}
                ></RankBar>
              ))}
            </BaseBar>
          </RowFlex>
        ))}
      </Content>
    </ChartContainer>
  )
}

export default Optimism
